const username = sessionStorage.getItem("username");

const chiefBaseUrl = process.env.REACT_APP_CHIEFAPI_URL;
const pipetopiaBaseUrl = process.env.REACT_APP_PIPETOPIAAPI_URL;

export const getCookie = async (cookieName) => {
  const response = await fetch(`${chiefBaseUrl}/cookies/getCookie?cookieName=${cookieName}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "include",
  });
  if (response.ok) {
    return await response.text();
  } else {
    return Promise.reject(response.text());
  }
};

export const setCookie = async (cookie) => {
  const response = await fetch(`${chiefBaseUrl}/cookies/setCookie`, {
    method: "POST",
    body: JSON.stringify(cookie),
    headers: {
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "include",
  });

  if (response.ok) {
    return await response.text();
  } else {
    return Promise.reject(response.text());
  }
};

export const deleteCookie = async (cookieName) => {
  const response = await fetch(`${chiefBaseUrl}/cookies/deleteCookie?cookieName=${cookieName}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "include",
  });
  if (response.ok) {
    return await response.text();
  } else {
    return Promise.reject(response.text());
  }
};

export const getUserLicenseBundleList = async (userId) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/UserLicenseBundleList?guid=${userId}`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getLicenseBundles = async () => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/CwfsCoreLicenseBundle`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const deleteUser = async (user) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/DeleteUser`, {
    method: "POST",
    body: JSON.stringify(user),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const updateUser = async (user) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/UpdateUser`, {
    method: "POST",
    body: JSON.stringify(user),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const addUserToDb = async (user) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/AddUser`, {
    method: "POST",
    body: JSON.stringify(user),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getUsers = async (userGuid) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/GetCwfsCoreUsers?userGuid=${userGuid}`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getUserActions = async () => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/GetUserActionRequests`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getCompletedUserActions = async () => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/GetCompletedUserActionRequests`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getBusinessUnits = async () => {
  return fetch(`${pipetopiaBaseUrl}/CrmBusinessUnit/CrmBusinessUnits?cwfsOnly=true&usingBcOnly=true`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const insertAddUserRequest = async (request) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/InsertAddUserRequest`, {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const insertUpdateUserRequest = async (request) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/InsertUpdateUserRequest`, {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const insertRemoveUserRequest = async (request) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/InsertRemoveUserRequest`, {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const updateAddUserRequest = async (request) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/UpdateAddUserRequest`, {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const updateRemoveUserRequest = async (request) => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/UpdateRemoveUserRequest`, {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getUsersWithAccessToSupportCenter = async () => {
  return fetch(`${pipetopiaBaseUrl}/CwfsCore/GetSupportCenterUsers`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
      username: username,
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getUserFromUsername = async (username) => {
  return fetch(`${pipetopiaBaseUrl}/CrmSystemUser/CrmUserByUserName?username=${username}`, {
    method: "GET",
    headers: {
      Authorization: await getChiefThumbsUp(),
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
  }).then(handleResponse);
};

export const getChiefThumbsUp = async () => {
  try {
    const thumbsUpCookie = await getCookie("chiefThumbsUp");
    return thumbsUpCookie;
  } catch {
    const token = await authenticateWithChief();
    return token;
  }
};

export const authenticateWithChief = async () => {
  const microsoftToken = await getCookie("microsoft-token");
  if (!microsoftToken) {
    alert("logging out ");
    logout();
  }
  const token = "Bearer " + microsoftToken;

  const path = `${chiefBaseUrl}/authenticateWithMicrosoftToken`;
  return new Promise((resolve, reject) => {
    fetch(path, {
      method: "GET",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.text())
      .then(async (text) => {
        await setCookie({ name: "chiefThumbsUp", value: "Bearer " + text, daysUntilExpire: 1 / 24 });
        resolve("Bearer " + text);
      })
      .catch(function (error) {
        console.error("Error in get " + path + " call: ", error);
      });
  });
};

export const logout = async () => {
  sessionStorage.removeItem("crmUser");
  await deleteCookie("chiefThumbsUp");
  await deleteCookie("microsoft-token");
  window.location.replace(process.env.REACT_APP_CWFSCORE_URL + "/login");
};

const handleResponse = async (response) => {
  let responseBody;
  try {
    responseBody = await response.json();
  } catch {
    console.warn("No JSON in response");
  }

  if (!response.ok) {
    if (response.status === 412) {
      alert("You do not have access to any Business Units, please contact itsupport@gocitywide.com for assistance.");
      logout();
      window.location.replace(process.env.REACT_APP_CWFSCORE_URL);
      return;
    }
    if (response.status === 401) {
      alert("Your session has expired! Logging out");
      logout();
      window.location.replace(process.env.REACT_APP_CWFSCORE_URL + "/login");
      return;
    }
    return Promise.reject(responseBody);
  } else {
    return responseBody;
  }
};
